import { render, staticRenderFns } from "./CreateItemChildModalForm.vue?vue&type=template&id=1ce3a800&scoped=true"
import script from "./CreateItemChildModalForm.vue?vue&type=script&lang=js"
export * from "./CreateItemChildModalForm.vue?vue&type=script&lang=js"
import style0 from "./CreateItemChildModalForm.vue?vue&type=style&index=0&id=1ce3a800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce3a800",
  null
  
)

export default component.exports